export default class BaseModel {
  constructor (obj) {
    this._id = obj.id
    this._name = obj.name
    this._parentId = obj.folder_id
    this._itemType = obj.itemType
  }

  get name () {
    return this._name
  }

  get id () {
    return this._id
  }

  get parentId () {
    return this._parentId
  }

  get itemType () {
    return this._itemType
  }
}



// WEBPACK FOOTER //
// ./src/models/base-model.js